import React from 'react';
import { Link } from 'react-router-dom';
import { useConfig } from '../../config/ConfigContext';

const HeroSection = () => {
  const { config } = useConfig();

  if (!config) return null;

  return (
    <section className="relative w-full h-screen overflow-hidden bg-gray-900">
      {/* Background Image */}
      <img
        src="/images/Bella/Product Photos/Replacement Video.JPG"
        alt="Luxury bedroom"
        className="absolute inset-0 w-full h-full object-cover opacity-60"
      />

      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-black/70 to-black/40" />


      {/* Content */}
      <div className="relative z-10 h-full flex items-center">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
          <div className="max-w-2xl text-white">
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-3 md:mb-4 leading-tight animate-swipe">
              Comfort that lasts
            </h1>
            <p className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl mb-4 md:mb-6 text-white leading-tight animate-swipe delay-100">
              Innovation <span className="font-script text-brand-red ml-2 text-4xl sm:text-5xl md:text-6xl lg:text-7xl">You Feel</span>
            </p>
            <p className="text-base sm:text-lg md:text-xl text-gray-200 mb-6 md:mb-8 leading-relaxed max-w-lg animate-swipe delay-200">
              Masters of crafting comfy Mattresses Since 1983
            </p>
            <Link
              to="/products"
              className="inline-block bg-brand-blue hover:bg-brand-red text-white font-semibold px-8 md:px-10 py-3 md:py-4 rounded-none transition-all duration-300 shadow-lg text-sm md:text-base"
            >
              View Our Collection
            </Link>
          </div>
        </div>
      </div>

    </section>
  );
};

export default HeroSection;


